const init = () => ({
  filter: {
    competitionId: localStorage.getItem('matches_competitionId') ? parseInt(localStorage.getItem('matches_competitionId')) : undefined,
    round: undefined,
    team: undefined,
    laddertemplate: undefined,
  },
  currentTab: 'explore',
});

export default {
  namespaced: true,
  state: init(),
  mutations: {
    setCurrentTab(state, payload) {
      console.log('setCurrentTab', payload);
      state.currentTab = payload;
    },
    clear(state) {
      const newState = init();
      Object.assign(state, newState);
    },
    setCompetitionId(state, payload) {
      state.filter.competitionId = payload;
      if (payload !== null && payload !== undefined) {
        localStorage.setItem('matches_competitionId', payload.toString());
      } else {
        localStorage.removeItem('matches_competitionId');
      }
    },
    setRound(state, payload) {
      state.filter.round = payload;
    },
    setTeam(state, payload) {
      state.filter.team = payload;
    },
    setLaddertemplate(state, payload) {
      state.filter.laddertemplate = payload;
    }
  },
  actions: {
  },
  getters: {
    getLaddertemplate(state) {
      return state.filter.laddertemplate;
    },
    currentTab(state) {
      return state.currentTab;
    },
    getCompetitionId(state) {
      return state.filter.competitionId;
    },
  },
};
